import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  type?: string;
}

const CategoryBadge: FC<Props> = ({ className, type }) => {
  return (
    <div
      className={twMerge(
        'absolute top-0 left-0 bg-gradient-to-b from-[#6199FF] to-[#045CFB] font-bold rounded-br-[5px] rounded-tl-[5px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] sm:w-[55px] w-[55px] sm:h-[18px] h-[15px] flex items-center justify-center text-[10px]/[12px] text-white',
        className,
      )}
    >
      {type}
    </div>
  );
};

export default CategoryBadge;
